import React from "react";
import axios from "axios";
import "./../css/Login.css";
import Footer from "../components/Footer";
import Banner from "../components/Banner";
import Spinner from "components/Spinner";

const API = localStorage.getItem("assethost");
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      ipAddress: "",
      country: "",
      isp: "",
      errors: {},
      msg: "",
      toastColor: "",
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.reset = this.reset.bind(this);
  }
  componentDidMount() {
    // If already logged in, redirect
    if (sessionStorage.getItem("token")) {
      window.location.href = "/dashboard";
      return;
    }
    // Get IP & geo info
    axios
      .get(
        "https://api.ipdata.co?api-key=212ad9acd89c4d7e42b8b70db2317c75e051aa7f16c81fed265ef9bd"
      )
      .then((res) => {
        this.setState({
          ipAddress: res.data.ip,
          country: res.data.country_name,
          isp: res.data.asn.name,
        });
      })
      .catch(() => {});
  }
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }
  validate() {
    let s = this.state;
    let errors = {},
      valid = true;
    if (!s.username || !s.username.trim()) {
      errors.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(s.username)) {
      errors.username = usernameError;
      valid = false;
    }
    if (!s.password || !s.password.trim()) {
      errors.password = "Password is required";
      valid = false;
    }
    this.setState({ errors, valid });
    return valid;
  }
  handleLogin(e) {
    if (e) e.preventDefault();
    if (!this.validate()) {
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    // Handle login
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let redirectUrl = params.get("redirectUrl");
    const dataObj = {
      username: this.state.username,
      password: this.state.password,
      ipAddress: this.state.ipAddress,
      country: this.state.country,
      isp: this.state.isp,
    };
    var self = this;
    axios
      .post(API + "/login/authenticate", dataObj)
      .then((res) => {
        if (res.data.error) {
          self.setState({
            msg: res.data.error,
            toastColor: "danger",
            loading: false,
          });
        } else if (!res.data.success) {
          self.setState({
            msg: res.data.message,
            toastColor: "danger",
            loading: false,
          });
        } else {
          // Success: do not set sessionStorage here (redirect to 2fa page)
          sessionStorage.removeItem("menus");
          window.location.href = `/auth/code?username=${
            self.state.username
          }&redirectUrl=${redirectUrl ? redirectUrl : ""}`;
        }
      })
      .catch((err) => {
        self.setState({
          msg: err.message || "Login failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      })
      .finally(() => {
        self.setState({ loading: false });
      });
  }
  reset(e) {
    if (e) e.preventDefault();
    window.location.href = "/auth/forgot";
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    if (s.loading) {
      return <Spinner className="" />;
    }
    return (
      <div className="min-h-screen flex flex-col ">
        <Banner title="Welcome to Asset Register" />
        {divMsg}
        <div className="flex w-full">
          <div className="w-1/2">
            <div className="text-center mb-6 px-12 text-base">
              <p className="text-black">
                Welcome to the Asset Register where you can register and track
                your assets, flag all assets that would have been stolen.
              </p>
              <p className="mt-4 text-black">
                Already have an account, please login.
                <br />
                New to the platform? Please register.
              </p>
            </div>
            <div className="flex-1 flex justify-center items-center">
              <div className="w-[400px] h-[250px] bg-sky-700/60 rounded-sm border flex items-center justify-center text-2xl text-black">
                Logo
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2 w-1/2 max-w-md">
            <form
              className="card space-y-4"
              autoComplete="off"
              onSubmit={this.handleLogin}
            >
              <h2 className="text-xl font-bold text-center">Login</h2>
              <div className="input-group">
                <label className="input-group-text">Username</label>
                <input
                  type="text"
                  name="username"
                  className={`form-control ${
                    s.errors.username ? " !border-red-500" : ""
                  }`}
                  value={s.username}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.username && (
                  <span className="input-group-error">{s.errors.username}</span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Password</label>
                <input
                  type="password"
                  name="password"
                  className={`form-control ${
                    s.errors.password ? " !border-red-500" : ""
                  }`}
                  value={s.password}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.password && (
                  <span className="input-group-error">{s.errors.password}</span>
                )}
              </div>
              <button type="submit" className="btn btn-success">
                Login
              </button>
              <button className="btn btn-success" onClick={this.reset}>
                Forgot Password
              </button>
            </form>
            <div className="card space-y-4">
              <h2 className="text-xl font-bold text-center">New User</h2>
              <a
                className="btn btn-success !w-80"
                href="/registration/individual"
              >
                Register as Individual
              </a>
              <a
                className="btn btn-success !w-80"
                href="/registration/corporate"
              >
                Register as Corporate
              </a>
              <a
                className="btn btn-success !w-80"
                href="/registration/traders-channel-partner"
              >
                Register as Traders/Channel Partner
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
